<template>
    <v-footer app v-if="isAuthenticated" style="background-color: #c0bebe;">
      <v-row>
        <v-col style="font-size: 12px; padding-top: 15px;">
          {{ Date() }}
        </v-col>
        <v-col align="right" style="font-size: 12px; padding-top: 15px;">
          &copy; copyright - coded by <a target="_blank" href="https://softcenter.bi">Soft Center Burundi.</a>
        </v-col>
      </v-row>
    </v-footer>
</template>

<script>
import { mapState } from 'vuex'
    export default {
        computed: {
            ...mapState({
                isAuthenticated: state => state.isAuthenticated,
            }),
        },
    }
</script>